var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "show-me" } }, [
    _vm.accountLastOrder
      ? _c("div", { staticClass: "last-orders-container__content" }, [
          _c("div", { staticClass: "title" }, [
            _c("h2", [_vm._v(_vm._s(_vm.$t("lastorders.lastOrder")))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text last-orders" }, [
            _c("div", { staticClass: "last-orders__type" }, [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.formatDate(_vm.accountLastOrder.date)),
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "last-orders__more-info" }, [
                _vm._v(
                  _vm._s(_vm.accountLastOrder.store.name) +
                    ", " +
                    _vm._s(
                      _vm.$t("lastorders." + _vm.accountLastOrder.deliveryType)
                    )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "last-orders__details" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.accountLastOrder.description) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            !_vm.processing
              ? _c(
                  "a",
                  {
                    staticClass: "lo-price-icon lo-price-icon--sm",
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onReorder(_vm.accountLastOrder)
                      },
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.accountLastOrder.priceFormatted)),
                    ]),
                    _vm._v(" "),
                    _c("SVGBasket"),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.processing
              ? _c("div", { staticClass: "last-orders__processing" }, [
                  _vm._v("\n        Loading\n        "),
                  _c("div", { staticClass: "dots dots--one" }, [_vm._v(".")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dots dots--two" }, [_vm._v(".")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dots dots--three" }, [_vm._v(".")]),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }